/** 邀请页的可见性: company_admin + 非 single 部署 + 非个人公司 */
import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/stores/auth-store";
import { usePublicConfig } from "@/features/auth/hooks";

export function useCanInvite(): boolean {
  const user = useAuthStore((s) => s.user);
  const config = usePublicConfig();
  return (
    user?.role === "company_admin" &&
    !!config.data &&
    config.data.deployment_mode !== "single" &&
    user.company_type !== "personal"
  );
}

export function InvitesRoute({ children }: { children: React.ReactNode }) {
  const canInvite = useCanInvite();
  const config = usePublicConfig();
  // 配置未加载完先不跳转, 避免刷新页面时被误踢
  if (config.isLoading) return null;
  if (!canInvite) return <Navigate to="/admin/users" replace />;
  return <>{children}</>;
}
